/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export type FullAddress = {
  UniqueId: number;
  FullAddress: string;
  SourceDesc: string;
  AddressType: string;
  Deliverable: boolean;
  AddressLine1: string;
  AddressLine2: string | null;
  AddressLine3: string | null;
  AddressLine4?: string | null;
  AddressLine5?: string | null;
  DPID: number;
  AddressId: number;
  ParcelId: number;
  Meshblock: number;
  StatsCensusYear: number;
  UnitType?: string | null;
  UnitValue?: string | null;
  LevelType?: string | null;
  LevelValue?: string | null;
  StreetNumber: number;
  StreetAlpha?: string | null;
  RoadName: string;
  RoadType: string;
  RoadSuffix?: string | null;
  SuburbLocality: string;
  RuralDelivery?: string | null;
  Lobby?: string | null;
  TownCity: string;
  Postcode: string;
  BoxBagNumber?: string | null;
  BoxBagType?: string | null;
  Position: {
    coordinates: [number, number];
    crs: {
      properties: {
        name: string;
      };
      type: string;
    };
    type: string;
  };
};

export const fullAddress = async (addressId: number) => {
  const url = `${process.env.REACT_APP_ADDRESS_API_URL}/fulladdress`;

  const subscriptionKey = process.env.REACT_APP_ADDRESS_API_KEY!;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": subscriptionKey,
    },
    body: JSON.stringify({
      searchString: addressId,
    }),
  });

  const data = (await response.json()) as FullAddress[];
  // Process the data
  return data;
};

export const constructStreetValue = (addressResponse: FullAddress) => {
  let address = "";
  if (addressResponse.AddressType === "PO Box") {
    if (!addressResponse.AddressLine3) {
      return addressResponse.AddressLine1;
    }
    return `${addressResponse.AddressLine1}, ${addressResponse.AddressLine2}`;
  } else if (addressResponse.AddressLine3) {
    address = `${addressResponse.AddressLine1}, ${addressResponse.AddressLine2}`;
  } else {
    address = `${addressResponse.AddressLine1}`;

    if (addressResponse.SuburbLocality) {
      address = `${address}, ${addressResponse.SuburbLocality}`;
    }

    if (addressResponse.UnitType) {
      address = `${address}, ${addressResponse.AddressLine2}`;
    }

    if (addressResponse.RuralDelivery) {
      address = `${address}, ${addressResponse.RuralDelivery}`;
    }
  }
  return address;
};
